import { render, staticRenderFns } from "./ImageUploadModal.vue?vue&type=template&id=0b88db14&scoped=true&"
import script from "./ImageUploadModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ImageUploadModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ImageUploadModal.vue?vue&type=style&index=0&id=0b88db14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88db14",
  null
  
)

export default component.exports